import admissions from './admissions/'
export default {
  admissions
}
